export const ThinArrowIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ flexShrink: 0 }}
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 6.76723H8.64564V6.76558C9.5501 6.76558 10.0015 5.67401 9.36296 5.03546L6.56751 2.24162L8.3091 0.5L15.8075 7.99836L8.30749 15.5L6.56585 13.7584L9.36296 10.9613C10.0015 10.3211 9.54845 9.22949 8.64564 9.22949H0V6.76723Z"
      fill="currentColor"
    />
  </svg>
);
